import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

const getDefaultState = () => {
  return {
    Toast: {
      isOpen: false,
      contents: "",
    },
    Modal: {
      isOpen: false,
      contents: "",
    },
    motpLedgerExistsYN: "N",
    /**
     * mOTP 기기정보
     */
    SSInfogetMotp: {
      in: {},
      out: [],
    },

    /**
     * mOTP 원장정보
     */
    motpLedgerInfo: {
      in: {
        operGroupCd: "",
        wWWBnkgLginID: "",
        mchtUniqNo: "",
      },
      out: {
        operGroupCd: "",
        iD: "",
        otpStusDstcd: "",
        coprPpsnDstcd: "",
        cin: "",
        wWWBnkgLginID: "",
        mchtlUniqNo: "",
        pinFailNotms: "",
        certnErrNotms: "",
        totalCertnSucssNotms: "",
        totalCertnErrNotms: "",
        frstCertnSucssLcalYMS: "",
        lastCertnDmndLcalYMS: "",
        lastCertnSucssLcalYMS: "",
        lastCertnErrLcalYMS: "",
        issuncLcalYMS: "",
        frstCertnSucssYMS: "",
        lastCertnDmndYMS: "",
        lastCertnSucssYMS: "",
        lastCertnErrYMS: "",
        issuncYMS: "",
        smphMchtlUniqNo: "",
        smphMchtlDstcd: "",
        pgmVsnno: "",
        certnDmndCd: "",
        smphMdelName: "",
        writYMS: "",
        lastAmndYMS: "",
        rmark: "",
      },
    },

    /**
     * 예금계좌상세조회(계좌 비밀번호 검증)
     */
    RBF0404B40: {
      acnoSelect: {
        acno: "",
        acnoDetail: {
          acnKnd: "",
          bal: 0,
          cnpr: 0,
          ctrcTrmCnt: 0,
          expirYmd: "",
          lnBal: 0,
          newYmd: "",
          ovsesCustOcntryName: "",
          totalExtenCnt: 0,
          wwwBnkgJoinAbilYn: "",
        },
      },
      in: {
        acno: "",
        brncoEcrypPwd: "",
        brncoEcrypPwdValdnYn: "0",
        acnDsticCd: "",
      },
      out: {},
    },

    /**
     * mOTP폐기
     */
    RBF0502J50: {
      in: {
        userIdnfr: "",
        otpSerno: "",
      },
      out: {},
    },

    /**
     * MOTP사고신고
     */
    acidntRprtReq: {
      in: {
        operGroupCd: "",
        cno: "",
        userIdnfr: "",
        ppsnCoprDstcd: "",
      },
      out: {},
    },

    /**
     * MOTP사고신고 해제
     */
    rcvocRprtReq: {
      in: {
        operGroupCd: "",
        cno: "",
        userIdnfr: "",
        ppsnCoprDstcd: "",
        mchtlUniqNo: "",
      },
      out: {},
    },
  };
};

const discardOrReportMotp = {
  computed: {},
  created() {},
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getToast: state => {
      return state.Toast;
    },
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    getMotpLedgerInfo: state => {
      return state.motpLedgerInfo;
    },
    getRBF0404B40: state => {
      return state.RBF0404B40;
    },
    getRBF0502J50: state => {
      return state.RBF0502J50;
    },
    getCheckOtp: state => {
      return state.checkOtp;
    },
    getAcidntRprtReq: state => {
      return state.acidntRprtReq;
    },
    getRcvocRprtReq: state => {
      return state.rcvocRprtReq;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut000: function(state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },

    mut001: function(state, payload) {
      this._vm.$set(state.RBF0502J50.in, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * 계좌인증
     */
    acnoCertn: function() {
      return new Promise(resolve => {
        // 계좌번호
        this.state.auth.discardOrReportMotp.RBF0404B40.in.acno = this.state.auth.discardOrReportMotp.RBF0404B40.acnoSelect.acno.split(";")[0];
        // 계좌구분코드
        this.state.auth.discardOrReportMotp.RBF0404B40.in.acnDsticCd = this.state.auth.discardOrReportMotp.RBF0404B40.acnoSelect.acnoDetail.acnKnd;

        this._vm.$post(
          "/account/inqury/AcnInqDtlPop",
          this.state.auth.discardOrReportMotp.RBF0404B40.in,
          response => {
            this.state.auth.discardOrReportMotp.RBF0404B40.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.discardOrReportMotp.RBF0404B40.out = response;
            resolve("fail");
          },
        );
      });
    },

    getMotpInfo: function() {
      this._vm.$log.info("native.smphMchtlUniqNo >>>> " + this.state.native.smphMchtlUniqNo);
      this._vm.$log.info("motpLedgerInfo.out.smphMchtlUniqNo >>>> " + this.state.auth.discardOrReportMotp.motpLedgerInfo.out.smphMchtlUniqNo);
      // if (
      //   this.state.auth.discardOrReportMotp.SSInfogetMotp.out.filter(item => {
      //     return item.strUserId === this.state.auth.discardOrReportMotp.motpLedgerInfo.out.iD;
      //   }).length > 0
      //   && (this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "030"     // 이용등록
      //     || this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "120"  // 사고신고
      //     || this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "131"  // 이용해지
      //     || this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "140"  // 오류횟수초과
      //   )
      //   && (this.state.auth.discardOrReportMotp.motpLedgerInfo.out.smphMchtlUniqNo === this.state.native.smphMchtlUniqNo)
      // ) {
      //   router.push({ name: "mainState1" });
      // } else {
      //   router.push({ name: "mainState3" });
      // }

      // mobile 내 삭제 가능한 mOTP Ledger 존재 여부 set
      if (
        this.state.auth.discardOrReportMotp.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.discardOrReportMotp.motpLedgerInfo.out.iD;
        }).length > 0 &&
        this.state.auth.discardOrReportMotp.motpLedgerInfo.out.smphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        this.state.auth.discardOrReportMotp.motpLedgerExistsYN = "Y";
      }

      // 어디서든지 폐기할 수 있도록 상태값만 check
      if (
        this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "030" || // 이용등록
        this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "120" || // 사고신고
        this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "131" || // 이용해지
        this.state.auth.discardOrReportMotp.motpLedgerInfo.out.otpStusDstcd === "140" // 오류횟수초과
      ) {
        router.push({ name: "mainState1" });
      } else {
        router.push({ name: "mainState3" });
      }
    },

    /**
     * brige for dicard
     */
    discardNtvMotp: function() {
      if (this.state.auth.discardOrReportMotp.motpLedgerExistsYN === "Y") {
        this._vm.$bridge.SSDiscardMotpPin(this.state.auth.discardOrReportMotp.motpLedgerInfo.out.iD);
      }
    },

    /**
     * Motp 원장조회
     */
    act000: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/getMotpLedger",
          this.state.auth.discardOrReportMotp.motpLedgerInfo.in,
          response => {
            this.state.auth.discardOrReportMotp.motpLedgerInfo.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.discardOrReportMotp.motpLedgerInfo.out = response;
            resolve("fail");
          },
        );
      });
    },

    /**
     * Motp폐기
     */
    act001: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/acidntRprt/motpDscrdRprt",
          this.state.auth.discardOrReportMotp.RBF0502J50.in,
          response => {
            this.state.auth.discardOrReportMotp.RBF0502J50.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.discardOrReportMotp.RBF0502J50.out = response;
            resolve("fail");
          },
        );
      });
    },

    /**
     * MOTP사고신고
     */
    act002: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/acidntRprt/motpAcidntRprt",
          this.state.auth.discardOrReportMotp.acidntRprtReq.in,
          response => {
            this.state.auth.discardOrReportMotp.acidntRprtReq.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.discardOrReportMotp.acidntRprtReq.out = response;
            resolve("fail");
          },
        );
      });
    },

    /**
     * MOTP사고신고 해제
     */
    act003: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/acidntRprt/motpRevocRprt",
          this.state.auth.discardOrReportMotp.motpLedgerInfo.in,
          response => {
            this.state.auth.discardOrReportMotp.rcvocRprtReq.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.discardOrReportMotp.rcvocRprtReq.out = response;
            resolve("fail");
          },
        );
      });
    },
  },
};

export default discardOrReportMotp;
